import { Injectable, OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ViewportService implements OnDestroy {
  private resizeObserver?: ResizeObserver;
  private mediaQueryList?: MediaQueryList;
  private boundHandleChange = this.handleChange.bind(this);

  constructor() {
    this.adjustRootFontSize();
    if (this.isWindows()) {
      this.setupListeners();
    }
  }

  private setupListeners(): void {
    window.addEventListener('resize', this.boundHandleChange);
    const dpr = window.devicePixelRatio || 1;
    this.mediaQueryList = window.matchMedia(`(resolution: ${dpr}dppx)`);

    if (this.mediaQueryList.addEventListener) {
      this.mediaQueryList.addEventListener('change', this.boundHandleChange);
    }
    else if (this.mediaQueryList.addListener) {
      this.mediaQueryList.addListener(this.boundHandleChange);
    }
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.handleChange();
      });
      this.resizeObserver.observe(document.documentElement);
    }
  }
  private handleChange(): void {
    this.adjustRootFontSize();

    this.updateMediaQuery();
  }

  private updateMediaQuery(): void {
    if (this.mediaQueryList) {
      if (this.mediaQueryList.removeEventListener) {
        this.mediaQueryList.removeEventListener('change', this.boundHandleChange);
      } else if (this.mediaQueryList.removeListener) {
        this.mediaQueryList.removeListener(this.boundHandleChange);
      }
    }

    const dpr = window.devicePixelRatio || 1;
    this.mediaQueryList = window.matchMedia(`(resolution: ${dpr}dppx)`);

    if (this.mediaQueryList.addEventListener) {
      this.mediaQueryList.addEventListener('change', this.boundHandleChange);
    } else if (this.mediaQueryList.addListener) {
      this.mediaQueryList.addListener(this.boundHandleChange);
    }
  }
  private getBaseFontSize(): number {
    const root = document.documentElement;
    const cssValue = getComputedStyle(root).getPropertyValue('--base-font-size');
    const parsed = parseFloat(cssValue);
    const computed = getComputedStyle(root).fontSize;
    const fallback = parseFloat(computed);
    return isNaN(parsed) ? fallback : parsed;
  }
  adjustRootFontSize(): void {
    if (!this.isWindows()) {
      document.documentElement.style.removeProperty('font-size');
      return;
    }

    const dpr = window.devicePixelRatio || 1;
    const baseFontSize = this.getBaseFontSize();
    let newSize = baseFontSize;

    if (dpr > 1 && dpr < 2) {
      newSize = baseFontSize / dpr;
    }

    document.documentElement.style.fontSize = `${newSize}px`;
  }

  private isWindows(): boolean {
    return /Windows/i.test(navigator.userAgent);
  }
  ngOnDestroy(): void {
    window.removeEventListener('resize', this.boundHandleChange);

    if (this.mediaQueryList) {
      if (this.mediaQueryList.removeEventListener) {
        this.mediaQueryList.removeEventListener('change', this.boundHandleChange);
      } else if (this.mediaQueryList.removeListener) {
        this.mediaQueryList.removeListener(this.boundHandleChange);
      }
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}
